"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.abyss = void 0;
var _merge = _interopRequireDefault(require("lodash/merge"));
var _uhg = require("./uhg");
var abyss = (0, _merge["default"])({}, _uhg.uhg, {
  theme: {
    colors: {
      primary1: '#003C71',
      accent1: '#196ECF',
      tint1: '#FAFCFF',
      tint2: '#E5F8FB',
      tint3: '#CCF2F7',
      tint4: '#99E5EE'
    }
  }
});
exports.abyss = abyss;